<template>
  <LayoutBasic :showLinksMenu="false" >
    <!-- Título del drawer -->
    <template v-slot:title>
      <v-list-item @click="$router.push('/pos')" class="hoverable">
        <v-list-item-icon>
          <v-icon large>mdi-view-dashboard</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="title font-weight-bold">Egresos</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
    </template>

    <!-- Encabezado principal -->
    <template v-slot:navigation-title>Gastos</template>

    <!-- Accesos laterales -->
    <template v-slot:navigation-after-links>
      <v-list dense nav >
        <!-- <v-list-item :to="{ name: 'pos.compra.factura' }" class="hoverable">
          <v-list-item-icon><v-icon>mdi-file-document</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Facturas</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->

        <!-- <v-list-item :to="{ name: 'pos.comprasPedidoListado' }"  class="hoverable">
          <v-list-item-icon><v-icon>mdi-clipboard-list</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Pedidos</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->

        <!-- <v-list-item :to="{ name: 'pos.comprasRemitoListado' }" class="hoverable">
          <v-list-item-icon><v-icon>mdi-truck-delivery-outline</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Remitos</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
      </v-list>
    </template>

    <!-- Contenido principal -->
    <template v-slot:vista-previa>
      <router-view />
    </template>
  </LayoutBasic>
</template>

<script>
import LayoutBasic from '@/layouts/LayoutBasic.vue'

export default {
  name: 'GastosPosLayout',
  components: { LayoutBasic },
  computed: {
     
  },
}
</script>
